export default {"src":"/_next/static/media/purple-arrow-up.4668770d.svg","height":50,"width":49,"blurWidth":0,"blurHeight":0};